<template>
  <div class="newsletter">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <b-tabs card>
              <b-tab title="Cadastro" active>
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-12">
                      <div class="title-section">Dados da newsletter</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for>
                          Assunto da Newsletter:
                          <span class="required-field">*</span>
                        </label>
                        <input type="text" v-model="newsletter.subject" class="form-control" />
                      </div>
                    </div>
                    <!-- <div class="col-12">
                  <div class="form-group">
                    <label for>Texto:</label>
                    <text-editor-component
                      :textContent="newsletter.text"
                      @updateContentComponent="updateContent"
                    ></text-editor-component>
                  </div>
                    </div>-->
                    <div class="col-12">
                      <div class="title-section">Período das notícias</div>
                    </div>
                    <div class="col-5">
                      <div class="form-group">
                        <label for>
                          Data inicial
                          <span class="required-field">*</span>
                        </label>
                        <b-form-datepicker
                          id="start-datepicker"
                          v-model="newsletter.start_date"
                          placeholder="Escolha uma data"
                          class="mb-2"
                        ></b-form-datepicker>
                      </div>
                    </div>
                    <div class="col-5">
                      <div class="form-group">
                        <label for>
                          Data final
                          <span class="required-field">*</span>
                        </label>
                        <b-form-datepicker
                          id="end-datepicker"
                          v-model="newsletter.end_date"
                          placeholder="Escolha uma data"
                          class="mb-2"
                        ></b-form-datepicker>
                      </div>
                    </div>
                    <div class="col-2" style="padding-top:31px">
                      <button class="btn btn-secondary float-right" v-on:click="getHtmlNews()">Gerar</button>
                    </div>
                    <div class="col-12" v-show="renderContent && newsletter.content_news">
                      <div class="form-group">
                        <text-editor-component
                          :textContent="newsletter.content_news"
                          @updateContentComponent="updateContentNews"
                        ></text-editor-component>
                        <!-- <text-editor-test-component></text-editor-test-component> -->
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <button class="btn btn-primary float-right" v-on:click="save()">Salvar</button>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Visualizar" :disabled="!(newsletter.content_news && newsletter.content_news != '')">
                <button class="btn btn-secondary" v-on:click="copyHtmlSource()">Copiar HTML</button>
                <div id="tableHtmlSource">
                  <table
                    width="500"
                    align="center"
                    cellpadding="0"
                    cellspacing="0"
                    style="border:5px #BD0101 solid"
                  >
                    <tr>
                      <td width="235">
                        <img
                          src="http://www.governet.com.br/templates/img/logo235x96.jpg"
                          width="235"
                          height="96"
                        />
                      </td>
                      <td width="215" align="right" style="padding:10px">
                        <font face="Tahoma" size="-2">
                          <strong>GOVERNET EDITORA LTDA. -EPP</strong>
                          <br />Sede Administrativa: Rua Waldemar Kost, 2170 – Casa 11, Condomínio Eldorado II CJ RES.
                          <br />Bairro: HAUER – CEP 81630-180 &bull; Curitiba/PR
                          <br /> (41) 3354-0295
                          <br />
                          <a
                            href="http://www.governet.com.br"
                            target="_blank"
                            style="text-decoration:none;color:#000000"
                          >www.governet.com.br</a>
                        </font>
                      </td>
                    </tr>
                    <tr>
                      <td
                        bgcolor="#BD0101"
                        align="center"
                        height="25"
                        colspan="2"
                        style="padding:5px"
                      >
                        <font face="Tahoma" size="3" color="#FFFFFF">
                          <strong>{{newsletter.subject}}</strong>
                        </font>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" style="padding:10px;font:12px Tahoma; color:#000000">
                        <font face="Tahoma" size="-1" color="#000000">
                          <div v-html="newsletter.content_news" class="text-content"></div>
                          <br />
                          <br />
                          <p>
                            <strong>
                              <font color="#BD0101">GOVERNET EDITORA LTDA.</font>
                            </strong>
                            <br />
                            <a
                              href="http://www.governet.com.br"
                              target="_blank"
                              style="text-decoration:none;color:#CC0000"
                            >www.governet.com.br</a>
                          </p>
                        </font>
                      </td>
                    </tr>
                  </table>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import TextEditorComponent from "@/components/inputs/TextEditorComponent";
import TextEditorTestComponent from "@/components/inputs/TextEditorTestComponent";
import Swal from "sweetalert2";
import validator from "@/imports/validator/validate";
import newsletter_validate from "@/imports/validator/models/newsletter";
import { bus } from "@/main";
import consulting from "../../../imports/validator/models/consulting";

export default {
  name: "newsletter",
  props: {
    id: Number
  },
  components: {
    TextEditorComponent,
    TextEditorTestComponent
  },
  data() {
    return {
      formType: "create",
      newsletter: {},
      renderContent: true,
      htmlcodesource: "",
      items: [
        {
          text: "Newsletters",
          route: "admin.newsletters"
        },
        {
          text: "Nova Newsletter",
          active: true
        }
      ]
    };
  },
  mounted() {
    if (this.id) {
      this.formType = "edit";
      this.getDataObject(this.id);
    }
  },
  methods: {
    getDataObject: function(id) {
      bus.$emit("changeLoading", true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/newsletters/${id}`)
        .then(response => {
          this.newsletter = response.data;
          this.items[1].text = this.newsletter.subject;
          bus.$emit("changeLoading", false);
        });
    },
    updateContent: function(val) {
      this.newsletter.text = val;
    },
    updateContentNews: function(val) {
      this.newsletter.content_news = val;
    },
    getHtmlNews: function() {
      if (!this.newsletter.start_date || !this.newsletter.end_date) {
        Swal.fire({
          title: "Atenção",
          text: "É preciso preencher as datas de inicio e fim",
          icon: "warning"
        });
      } else {
        let promise = axios.get(
          `${process.env.VUE_APP_API_HOST}/api/generate_html_news?start_date=${this.newsletter.start_date}&end_date=${this.newsletter.end_date}`
        );
        this.renderContent = false;
        promise.then(response => {
          this.newsletter.content_news = "";
          if (response.data != "") {
            this.newsletter.content_news = response.data;
          } else {
            Swal.fire({
              title: "Atenção",
              text: "O período selecionado não contém notícias",
              icon: "warning"
            });
            this.newsletter.start_date = null;
            this.newsletter.end_date = null;
          }
          this.renderContent = true;
        });
      }
    },
    copyHtmlSource: function() {
      let tableHtml = document.getElementById("tableHtmlSource");

      const el = document.createElement("textarea");
      el.value = tableHtml.innerHTML;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);

      Swal.fire({
        title: "O código HTML foi copiado!",
        icon: "success"
      });
    },
    save: function() {
      let errors = validator.validate(
        this.newsletter,
        newsletter_validate.model
      );

      if (errors.length == 0) {
        bus.$emit("changeLoading", true);

        let promise =
          this.formType == "create"
            ? axios.post(
                `${process.env.VUE_APP_API_HOST}/api/newsletters`,
                this.newsletter
              )
            : axios.put(
                `${process.env.VUE_APP_API_HOST}/api/newsletters/${this.newsletter.id}`,
                this.newsletter
              );

        promise.then(response => {
          bus.$emit("changeLoading", false);
          Swal.fire({
            title:
              this.formType == "create"
                ? "Nova newsletter cadastrada"
                : "Newsletter alterada com sucesso",
            icon: "success",
            onClose: () => {
              this.$router.push({ name: "admin.newsletters" });
            }
          }).catch(error => {
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
        });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach(el => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.newsletter {
  .card-header {
    background-color: white;
    a {
      text-decoration: none;
      color: $red_primary;
    }
  }
}
</style>